// ----------------------------------------------------------------------------
// Template: Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/pagination/pagination';
import 'sections/header/header';
import 'sections/hero/hero';
import 'sections/main-search/main-search';
import 'snippets/_containers/aside/aside';
import 'snippets/algolia-listing/algolia-listing';
import 'sections/footer/footer';